<template>
  <div class="box">
    <PageHeader title="مدیریت کاربران" :items="pageHeaderItems" />
    <Loader v-if="loading" />
    <b-row v-else>
      <b-col cols="12" md="12">
        <div class="card">
          <Section title="اطلاعات کاربر">
            <div class="d-flex mb-3">
              <div class="w-50">
                <BaseText :maxlength="2000" v-model="model.firstname" required title="نام" placeholder="نام" :errortext="errorText" :showError="submit && !model.firstname" />
              </div>

              <div class="w-50 ps-3">
                <BaseText
                  :maxlength="2000"
                  v-model="model.lastname"
                  required
                  title="نام خانوادگی"
                  placeholder="نام خانوادگی"
                  :errortext="errorText"
                  :showError="submit && !model.lastname"
                />
              </div>
            </div>

            <div class="d-flex">
              <div class="w-50">
                <BaseText
                  :maxlength="2000"
                  v-model="model.phone"
                  title="تلفن همراه"
                  :required="model.phone.length < 11"
                  :disable="model.phone.length >= 11 && $route.path !== '/list/manageusers/add'"
                  inputType="number"
                  placeholder="تلفن همراه"
                  :errortext="errorText"
                  :showError="submit && !model.phone.length"
                />
              </div>
              <div class="w-50 ps-3">
                <ComboBox
                  :searchedData="roles"
                  title="نقش"
                  placeholder="نقش"
                  :selectedValue="selectedRole"
                  required
                  @select="fillSelectedRole"
                  :inputStyle="comboStyle"
                  :errortext="errorText"
                  :showError="submit && !model.role"
                />
              </div>
            </div>
            <div class="d-flex">
              <div class="my-3 w-50">
                <BaseText
                  :maxlength="2000"
                  v-model="model.password"
                  title="پسورد"
                  required
                  placeholder="پسورد"
                  :errortext="errorText"
                  :showError="submit && !model.password && $route.path === '/list/manageusers/add'"
                />
              </div>

              <div class="w-50 my-3 ps-3">
                <BaseText
                  :maxlength="2000"
                  v-model="model.confirmPassword"
                  title="تکرار پسورد"
                  required
                  placeholder="تکرار پسورد"
                  :errortext="errorText"
                  :showError="submit && !model.confirmPassword && $route.path === '/list/manageusers/add'"
                />
              </div>
            </div>

            <BaseText :maxlength="2000" :value="model.email" @input="model.email = $event" title="ایمیل" placeholder="ایمیل" />
          </Section>
        </div>

        <!-- <div class="card">
          <Section>
            <div class="p-2">
              <Table :tableData="dataTables" />
            </div>
          </Section>
        </div> -->
        <div class="card p-3 d-flex flex-row justify-content-end">
          <b-button @click="$router.push('/list/manageusers')">انصراف</b-button>
          <b-button variant="primary ms-2 px-5" @click="addUser">ثبت</b-button>
        </div>
      </b-col>
    </b-row>

    <Toast :title="message" :error="error" :showToast="showToast" />
  </div>
</template>
<script>
import PageHeader from '../../layoutComponents/page-header.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import moocUsersProvider from '../../../services/mooc/user'
import Toast from '../../common/Toast.vue'
import Loader from '../../widgets/loader.vue'
import Section from '../../common/form/Section.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import userDataProvider from '../../../services/user'
// import Table from '../../../common/table/simpleTable/index.vue'

export default {
  name: 'AddUser',
  components: { PageHeader, BaseText, Toast, Loader, Section, ComboBox },
  props: {
    create: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imageCrop: { width: 180, height: 180 },
      model: {
        password: '',
        confirmPassword: '',
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
      },
      errorText: 'وارد کردن این فیلد الزامی است',
      message: '',
      cropperLoading: false,
      submit: false,
      error: false,
      showToast: false,
      loading: false,
      roles: [],
      dataTables: {},
      selectedRole: '',
      comboStyle: 'color: #495057',

      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت دانشکده', active: true },
      ],
    }
  },
  async mounted() {
    if (this.update) {
      this.fetchUser()
    } else {
      this.getAvailableRoles()
    }
  },
  // beforeMount() {
  //   userDataProvider
  //     .getUserProfileItemsData(`https://utapg.cloudware.ir/university/api/skillup/AdminUserOrders`, {
  //       peopleId: this.$route.params.id,
  //       searchDto: {
  //         key: 'Ordering-2',
  //         query: '',
  //         pageSize: 10,
  //         pageNumber: 1,
  //         sortBy: '',
  //         isSortAsc: true,
  //         fieldSearchs: [
  //           {
  //             fieldName: '',
  //             type: '',
  //             text: '',
  //             startDate: '2022-01-11T13:02:10.671Z',
  //             endDate: '2022-01-11T13:02:10.671Z',
  //             min: 0,
  //             max: 0,
  //             opration: '',
  //             options: [0],
  //           },
  //         ],
  //       },
  //     })
  //     .then((res) => {
  //       this.dataTables = res.data
  //     })
  //     .catch((err) => {
  //       console.log(err)
  //     })
  //   this.$router.push({ path: `${this.$route.path}?navLink=SupplementaryInfo` }).catch(() => {})
  // },
  methods: {
    async getAvailableRoles() {
      const req = await moocUsersProvider.getAvailableRoles()
      this.roles = req.data
    },
    fillSelectedRole(e) {
      if (!e) {
        this.model.role = null
        return false
      }
      this.model.role = this.roles.find((item) => item.value === e).key
    },
    async addUser() {
      try {
        this.submit = true
        if (
          !this.model.firstname ||
          !this.model.lastname ||
          (!this.model.password && this.model.password !== this.model.confirmPassword && this.$route.path === '/list/manageusers/add') ||
          !this.model.phone ||
          !this.model.role
        ) {
          return false
        }
        this.loading = true

        if (this.update) {
          const req = await moocUsersProvider.updateAdminFacaltyUser(this.model)
          if (req.status >= 200 && req.status <= 202) {
            this.showToast = false
            this.$nextTick(() => {
              this.showToast = true
              this.error = false
              this.message = 'اطلاعات با موفقیت ثبت شد.'
            })
            this.fetchUser()
            // this.$router.push('/list/manageusers')
          } else {
            this.showToast = false
            this.$nextTick(() => {
              this.showToast = true
              this.error = true
              this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
            })
          }
          this.loading = false
          return false
        }
        const req = await moocUsersProvider.createAdminFacaltyUser(this.model)
        if (req.status >= 200 && req.status <= 202) {
          this.message = 'اطلاعات با موفقیت ثبت شد.'
          this.$router.push('/list/manageusers')
        } else {
          this.showToast = false
          this.$nextTick(() => {
            this.showToast = true
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          })
        }
        this.loading = false
        return false
      } catch (error) {
        this.loading = false
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.error = true
          this.message = error.response.data.message
        })
      }
    },
    async fetchUser() {
      this.loading = true
      try {
        const req = await moocUsersProvider.getAdminFacaltyUser(this.$route.params.id)
        this.model = req.data
        this.roles = this.model.roles
        this.roles.filter((item) => {
          if (item.key === this.model.role) {
            this.selectedRole = item.value
          }
        })
        delete this.model.roles
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.box {
  height: 100vh;
}
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.sections {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 1rem;
}

.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo {
  height: 122px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
    // font-size: 20px;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    // font-size: 18px;
    color: #ff4861;
    // font-weight: 100;
  }
}
.previewImage {
  border-radius: 4px;
}
.checkbox-margin {
  margin-right: 8px;
}

::v-deep .custom-control-label {
  margin-right: 10px !important;
}

::v-deep .custom-control-input {
  border: 1px solid #556ee6 !important;
}

::v-deep .b-form-tags-button {
  display: none;
}
.part {
  display: inline-flex;
  width: 50%;
}

::v-deep .card {
  overflow-y: unset;
  overflow-x: unset;
}
</style>
